import aloopAxios from "@aloop-util/axios";

let setting = {
  keys: { storage_auth: "__al_a", storage_view_id: "__al_vid" },
};
let aloop = aloopAxios(setting);

aloop.events({
  onCreate(e) {
    e.viewid().domain(process.env.VUE_APP_API_DOMAIN).authorization();
  },
  onResponse(e) {
    let headers = e.headers || e?.response?.headers || null;

    if (headers) {
      let viewid = headers.get("view-id");
      if (viewid) localStorage.setItem(setting.keys.storage_view_id, viewid);
    }
  },
});

const auth = {
  profile(payload) {
    return aloop.create({
      payload,
      method: "GET",
      path: "auth/profile",
    });
  },

  attempt(payload) {
    return aloop.create({
      payload,
      method: "POST",
      path: "auth/login/attempt",
    });
  },

  verify(payload) {
    return aloop.create({
      payload,
      method: "POST",
      path: "auth/login/verify",
    });
  },

  logout(payload) {
    return aloop.create({
      payload,
      method: "POST",
      path: "auth/logout",
    });
  },
};

const password = {
  attempt(payload) {
    return aloop.create({
      payload,
      method: "POST",
      path: "auth/password/attempt",
    });
  },

  reset(payload) {
    return aloop.create({
      payload,
      method: "POST",
      path: "auth/password/reset",
    });
  },
};

const user = {
  search(payload) {
    return aloop.create({
      payload,
      method: "GET",
      path: "admin/users",
    });
  },

  create(payload) {
    return aloop.create({
      payload,
      method: "POST",
      path: "admin/users",
    });
  },

  update(payload) {
    return aloop.create({
      payload,
      method: "PUT",
      path: "admin/users",
    });
  },

  delete(payload) {
    return aloop.create({
      payload,
      method: "DELETE",
      path: "admin/users",
    });
  },

  clearTwoFactor(payload) {
    return aloop.create({
      payload,
      method: "DELETE",
      path: "admin/users/two-factor",
    });
  },
};

const team = {
  search(payload) {
    return aloop.create({
      payload,
      method: "GET",
      path: "admin/teams",
    });
  },

  create(payload) {
    return aloop.create({
      payload,
      method: "POST",
      path: "admin/teams",
    });
  },

  update(payload) {
    return aloop.create({
      payload,
      method: "PUT",
      path: "admin/teams",
    });
  },

  delete(payload) {
    return aloop.create({
      payload,
      method: "DELETE",
      path: "admin/teams",
    });
  },
};

const cpd = {
  search(payload) {
    return aloop.create({
      payload,
      method: "GET",
      path: "admin/cpds",
    });
  },

  create(payload) {
    return aloop.create({
      payload,
      method: "POST",
      path: "admin/cpds",
    });
  },

  createRef(payload) {
    return aloop.create({
      payload,
      method: "POST",
      path: "admin/cpds/ref",
    });
  },

  update(payload) {
    return aloop.create({
      payload,
      method: "PUT",
      path: "admin/cpds",
    });
  },

  delete(payload) {
    return aloop.create({
      payload,
      method: "DELETE",
      path: "admin/cpds",
    });
  },

  active(payload) {
    return aloop.create({
      payload,
      method: "PUT",
      path: "admin/cpds/active",
    });
  },

  display(payload) {
    return aloop.create({
      payload,
      method: "PUT",
      path: "admin/cpds/display",
    });
  },

  render(payload) {
    return aloop.create({
      payload,
      method: "POST",
      path: "admin/cpds/render",
    });
  },

  expirationSoon(payload) {
    return aloop.create({
      payload,
      method: "GET",
      path: "admin/cpds/expiration-soon",
    });
  },

  history(payload) {
    return aloop.create({
      payload,
      method: "GET",
      path: "admin/cpds/history",
    });
  },
};

const config = {
  master(payload) {
    return aloop.create({
      payload,
      method: "GET",
      path: "admin/config/master",
    });
  },

  externalDomains(payload) {
    return aloop.create({
      payload,
      method: "GET",
      path: "admin/config/external-domains",
    });
  },
};

const statistic = {
  cpd(payload) {
    return aloop.create({
      payload,
      method: "GET",
      path: "admin/statistic/cpd",
    });
  },

  cost(payload) {
    return aloop.create({
      payload,
      method: "GET",
      path: "admin/statistic/cost",
    });
  }
};

const file = {
  upload(payload) {
    return aloop.create({
      payload,
      method: "POST",
      path: "admin/files",
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  },

  delete(payload) {
    return aloop.create({
      payload,
      method: "DELETE",
      path: "admin/files",
    });
  },
};

export default {
  parent: aloop,
  auth,
  password,
  user,
  team,
  cpd,
  config,
  file,
  statistic
};
